import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import store from '@/store'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useRoleEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router, route } = useRouter()
  const { updateItem, getItem } = useLambda()
  const { addAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const item = ref(null)
  const originalData = ref(null)
  const isSubmitting = ref(false)
  const query = { _id: oid(route.value.params.id), client_id: oid(userData.client.$oid) }
  const collection = 'role'

  const show = async () => {
    isSubmitting.value = true

    try {
      const roleData = await getItem({ collection, query })

      // Inicializar history si no existe (documentos legacy)
      if (!roleData.history) {
        roleData.history = []
      }

      item.value = {...roleData, subroles: roleData.subroles?.map(e => e.toString()) || []}
      // Guardar estado original para audit log (deep clone)
      originalData.value = JSON.parse(JSON.stringify(roleData))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.role_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  const update = async dataObject => {
    if (!hasPermission('organization-roles', 'edit')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      dataObject.subroles = dataObject.subroles?.map(e => oid(e)) || []

      const action = { $set: dataObject }

      // Actualizar documento
      await updateItem({ collection, query, action })

      // Registrar en logs de auditoría
      await addAuditEntry({
        collection,
        documentId: route.value.params.id,
        originalData: originalData.value,
        updatedData: { ...item.value, ...dataObject },
      })

      showSuccessMessage(i18n.t('message.form_success'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.role_update_error'))
    } finally {
      router.push({ name: 'organization-role-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    item,
    isSubmitting,
  }
}
